(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDetailController', HandbookMergeItemDetailController);

    HandbookMergeItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookMergeItem', 'HandbookNode', 'HandbookMergeHeader'];

    function HandbookMergeItemDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookMergeItem, HandbookNode, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookMergeItemUpdate', function(event, result) {
            vm.handbookMergeItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
